import { useMemo } from 'react';
import ReactTooltip from 'react-tooltip';

interface TruncatedCellProps {
  text?: string | null;
  maxLength?: number;
  emptyValue?: string;
  className?: string;
}

const TruncatedCell = ({ text, maxLength = 50, emptyValue = '-', className }: TruncatedCellProps) => {
  const id = useMemo(() => `tc-${Math.random().toString(36).slice(2, 9)}`, []);
  if (!text || !String(text).trim()) return <span className={className}>{emptyValue}</span>;
  const raw = String(text);
  const isTruncated = raw.length > maxLength;
  const display = isTruncated ? `${raw.slice(0, maxLength)}…` : raw;
  return (
    <>
      <span
        data-tip={isTruncated ? raw : undefined}
        data-for={isTruncated ? id : undefined}
        className={className}
        style={{
          display: 'inline-block',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          verticalAlign: 'bottom',
          cursor: isTruncated ? 'help' : 'default',
        }}
      >
        {display}
      </span>
      {isTruncated && <ReactTooltip id={id} effect="solid" multiline />}
    </>
  );
};

export default TruncatedCell;
